import { Helmet } from 'react-helmet'
import Header from '../../../Components/Header'
import MainContent from './MainContent'

const AssemblyList = () => {
  
  return (
    <div className='d-flex flex-column' style={{ height: '99.9vh' }}>
      <Helmet>
				<title>Work Order List</title>
			</Helmet>
    <Header />
    <MainContent />
     </div>
  )
}

export default AssemblyList